import { useState, useEffect } from 'react';
import { useSalon } from '../contexts/SalonContext';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const useNotificationCounts = () => {
  const { salonId } = useSalon();
  const [pendingCounts, setPendingCounts] = useState({
    appointments: 0,
    confirmations: 0
  });
  
  useEffect(() => {
    if (!salonId) return;
    
    const fetchPendingCounts = async () => {
      try {
        // Buscar agendamentos pendentes
        const appointmentsRef = collection(db, `salons/${salonId}/appointments`);
        const pendingQuery = query(
          appointmentsRef,
          where('confirmado', '==', false),
          where('cancelado', '==', false)
        );
        const pendingSnapshot = await getDocs(pendingQuery);
        
        setPendingCounts({
          // Não exibir contador na agenda, apenas em confirmações
          appointments: 0,
          confirmations: pendingSnapshot.size
        });
      } catch (error) {
        console.error('Erro ao buscar contadores:', error);
      }
    };
    
    fetchPendingCounts();
    
    // Idealmente, configurar um listener para atualizações em tempo real
  }, [salonId]);
  
  return pendingCounts;
};
